import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Home from "@/pages/Home";
import Booking from "@/pages/Booking";
import BookingDetail from "@/pages/BookingDetail";
import BookingSuccess from "@/pages/BookingSuccess";
import BookingPaypalSuccess from "@/pages/BookingPaypalSuccess";
import Feedback from "@/pages/Feedback";
import Fleet from "@/pages/Fleet";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";

function App() {
  return (
    <div className="App bg-[#050a12] min-h-screen text-[#f0f6fb]">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/book" element={<Booking />} />
          <Route path="/book/:packageId" element={<Booking />} />
          <Route path="/booking/:bookingId" element={<BookingDetail />} />
          <Route path="/booking/success" element={<BookingSuccess />} />
          <Route path="/booking/paypal-success" element={<BookingPaypalSuccess />} />
          <Route path="/feedback/:bookingId" element={<Feedback />} />
          <Route path="/fleet" element={<Fleet />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/admin" element={<AdminLogin />} />
          <Route path="/admin/dashboard" element={<AdminDashboard />} />
        </Routes>
      </BrowserRouter>
      <Toaster theme="dark" position="top-right" richColors />
    </div>
  );
}

export default App;
